import { FC, HTMLAttributes } from "react";
import styled from "styled-components";

type Props = HTMLAttributes<HTMLButtonElement> & {
  label: string;
  color: string;
  arrowImage: string;
};
const SeeMoreButton: FC<Props> = ({ label, color, arrowImage, ...props }) => {
  return (
    <Root {...props} $color={color}>
      <Label $color={color}>{label}</Label>
      <Arrow src={arrowImage} />
    </Root>
  );
};
export default SeeMoreButton;

const Root = styled.button<{ $color: string }>`
  display: flex;
  align-items: center;
  padding: 0.4em 0.8em;
  position: relative;
  
  &:after {
    position: absolute;
    bottom: -4px;
    left: 0;
    content: '';
    width: 100%;
    height: 3px;
    background-color: ${({ $color }) => $color};
    transform: scale(0, 1);
    transform-origin: center top;
    transition: transform .3s;
  }

  &:hover::after {
    transform: scale(1, 1);
  }
`;

const Label = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-family: sans-serif;
  font-size: 1.24em;
  font-weight: bold;
  font-style: italic;
  line-height: 1;
`;

const Arrow = styled.img`
  margin-left: 8px;
  width: 15px;
  height: 10.2px;
`;
